/** @jsxImportSource @emotion/react */
import Skeleton from "components/common/Skeleton";
import skeletonCss from "./index.css";

export default function SkeletonCell() {
  return (
    <div css={skeletonCss}>
      <Skeleton />
    </div>
  );
}
